export default function AIIcon({ className }: { className?: string }) {
  return (
    <span className={`inline-block relative ${className}`}>
      <svg
        className="w-full h-full"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="20" cy="20" r="20" fill="#5B21B6" fillOpacity="0.5" />
        <circle
          cx="20.3703"
          cy="20.3704"
          r="14.4444"
          fill="#5B21B6"
          fillOpacity="0.3"
        />
        <circle cx="20.3704" cy="20.3704" r="10" fill="#5B21B6" />
        <g clipPath="url(#clip0_ai_icon)">
          <path
            d="M20.0096 15.4637C20.0307 15.3504 20.0908 15.2481 20.1795 15.1745C20.2681 15.1009 20.3798 15.0605 20.495 15.0605C20.6102 15.0605 20.7218 15.1009 20.8105 15.1745C20.8992 15.2481 20.9593 15.3504 20.9804 15.4637L21.4994 18.2084C21.5363 18.4035 21.6311 18.583 21.7716 18.7234C21.912 18.8639 22.0915 18.9587 22.2866 18.9956L25.0313 19.5146C25.1446 19.5357 25.2469 19.5958 25.3205 19.6845C25.3941 19.7731 25.4344 19.8848 25.4344 20C25.4344 20.1152 25.3941 20.2269 25.3205 20.3155C25.2469 20.4042 25.1446 20.4643 25.0313 20.4854L22.2866 21.0044C22.0915 21.0413 21.912 21.1361 21.7716 21.2766C21.6311 21.417 21.5363 21.5965 21.4994 21.7916L20.9804 24.5363C20.9593 24.6496 20.8992 24.7519 20.8105 24.8255C20.7218 24.8992 20.6102 24.9395 20.495 24.9395C20.3798 24.9395 20.2681 24.8992 20.1795 24.8255C20.0908 24.7519 20.0307 24.6496 20.0096 24.5363L19.4906 21.7916C19.4537 21.5965 19.3589 21.417 19.2184 21.2766C19.078 21.1361 18.8985 21.0413 18.7034 21.0044L15.9587 20.4854C15.8454 20.4643 15.7431 20.4042 15.6695 20.3155C15.5958 20.2269 15.5555 20.1152 15.5555 20C15.5555 19.8848 15.5958 19.7731 15.6695 19.6845C15.7431 19.5958 15.8454 19.5357 15.9587 19.5146L18.7034 18.9956C18.8985 18.9587 19.078 18.8639 19.2184 18.7234C19.3589 18.583 19.4537 18.4035 19.4906 18.2084L20.0096 15.4637Z"
            stroke="white"
            strokeWidth="0.641975"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.4457 15.0617V17.037"
            stroke="white"
            strokeWidth="0.641975"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.4332 16.0493H23.4579"
            stroke="white"
            strokeWidth="0.641975"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.5444 24.9382C17.0899 24.9382 17.5321 24.496 17.5321 23.9506C17.5321 23.4051 17.0899 22.9629 16.5444 22.9629C15.999 22.9629 15.5568 23.4051 15.5568 23.9506C15.5568 24.496 15.999 24.9382 16.5444 24.9382Z"
            stroke="white"
            strokeWidth="0.641975"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_ai_icon">
            <rect
              width="11.8519"
              height="11.8519"
              fill="white"
              transform="translate(14.0741 14.0741)"
            />
          </clipPath>
        </defs>
      </svg>
      <span className="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full bg-green-500 ring-1 ring-white" />
    </span>
  );
}
